/* eslint-disable indent */
/* eslint-disable no-unused-vars */
/* eslint-disable quotes */
import "./style.scss";
import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  Select,
  Modal,
  Row,
  Col,
  Input,
  message,
  Checkbox,
  Typography,
  Switch,
} from "antd";
import TableContainer from "../../../components/TableContainer";
import API from "../../../api";
import urls from "../../../api/urls";
import {
  DeleteOutlined,
  PlusOutlined,
} from "@ant-design/icons";

const { TextArea } = Input;
const { Text } = Typography;
const { DELIVERY_PARTNER_LIST, SERVICEABILITY_API } = urls;

const DPPincodeList = ({ type }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isBulkModalOpen, setIsBulkModalOpen] = useState(false);
  const [pincodeToDelete, setPincodeToDelete] = useState(null);
  const [pincode, setPincode] = useState("");
  const [bulkInput, setBulkInput] = useState("");
  const [bulkErrorMessage, setBulkErrorMessage] = useState("");
  const [bulkFM, setBulkFM] = useState(false);
  const [bulkLM, setBulkLM] = useState(false);
  const [bulkCOD, setBulkCOD] = useState(false);
  const [validPincodes, setValidPincodes] = useState([]);
  const [city, setCity] = useState("");
  const [deliveryPartners, setDeliveryPartners] = useState([]);
  const [selectedDP, setSelectedDP] = useState(null);
  const [selectedType, setSelectedType] = useState(type);
  const [pincodes, setPincodes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fm, setFM] = useState(false);
  const [lm, setLM] = useState(false);
  const [cod, setCOD] = useState(false);

  useEffect(() => {
    fetchDeliveryPartners();
  }, []);

  useEffect(() => {
    if (selectedDP) {
      fetchPincodes();
    } else {
      setPincodes([]);
    }
  }, [selectedDP]);

  const fetchDeliveryPartners = async () => {
    try {
      setLoading(true);
      let result = await API.Api(
        `${DELIVERY_PARTNER_LIST}?limit=500&dpType=${type}`
      ).get();
      let response = result?.response?.data?.data;
      setDeliveryPartners(response);
    } catch (error) {
      message.error("Failed to fetch delivery partners");
    } finally {
      setLoading(false);
    }
  };

  const fetchPincodes = async () => {
    try {
      setLoading(true);
      let result = await API.Api(
        `${SERVICEABILITY_API}?dpId=${selectedDP}&type=${type}`
      ).get();
      let response = result?.response?.data?.data || [];
      setPincodes(response);
    } catch (error) {
      message.error("Failed to fetch pincodes");
      setPincodes([]);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setPincode("");
    setCity("");
    setSelectedType(type);
    setFM(false);
    setLM(false);
    setCOD(false);
  };

  const handleBulkCancel = () => {
    setIsBulkModalOpen(false);
    setBulkInput("");
    setBulkErrorMessage("");
    setBulkFM(false);
    setBulkLM(false);
    setBulkCOD(false);
    setValidPincodes([]);
  };

  const handleDeleteCancel = () => {
    setIsDeleteModalOpen(false);
    setPincodeToDelete(null);
  };

  const showDeleteConfirm = (pincode) => {
    setPincodeToDelete(pincode);
    setIsDeleteModalOpen(true);
  };

  const confirmDelete = async () => {
    if (!pincodeToDelete) return;

    try {
      setLoading(true);

      // Get the user token from localStorage
      const userinfo = JSON.parse(localStorage.getItem("userinfo"));
      const userToken = userinfo?.accessToken;

      if (!userToken) {
        message.error("Authentication token not found");
        setLoading(false);
        return;
      }

      // Use API utility with custom headers to match the curl command
      const result = await API.Api(SERVICEABILITY_API).deleteHeader({
        dpId: selectedDP,
        pincode: parseInt(pincodeToDelete),
        type: selectedType,
      });

      if (
        result?.response?.status === 200 ||
        result?.response?.status === 204
      ) {
        message.success(result?.response?.data?.message);
        fetchPincodes();
      } else {
        message.error(
          result?.response?.data?.message || "Failed to delete pincode"
        );
      }
    } catch (error) {
      console.error("Delete error:", error);
      message.error(
        error?.response?.data?.message || "Failed to delete pincode"
      );
    } finally {
      setLoading(false);
      setIsDeleteModalOpen(false);
      setPincodeToDelete(null);
    }
  };

  const handlePincodeChange = (e) => {
    setPincode(e.target.value);
  };

  const handleTypeChange = (value) => {
    setSelectedType(value);
  };

  const handleBulkInputChange = (e) => {
    setBulkInput(e.target.value);
    setBulkErrorMessage("");
  };

  const handleCheckboxChange = async (pincode, field, checked) => {
    try {
      setLoading(true);

      // Find the current pincode data to get existing values
      const pincodeData = pincodes.find((p) => p.pincode === pincode);
      if (!pincodeData) {
        message.error("Pincode data not found");
        setLoading(false);
        return;
      }

      // Construct the complete payload with all required fields
      const payload = {
        dpId: selectedDP,
        pincode: parseInt(pincode),
        type: selectedType,
        FM: field === "FM" ? checked : !!pincodeData.FM,
        LM: field === "LM" ? checked : !!pincodeData.LM,
        isCod: field === "isCod" ? checked : !!pincodeData.isCod,
      };

      // Use PATCH method as shown in the curl example
      const result = await API.Api(SERVICEABILITY_API).patchCustomHeader(
        payload,
        {
          kid: "1",
          authtype: "jwt",
          "Content-Type": "application/json",
        }
      );

      if (
        result?.response?.status === 200 ||
        result?.response?.status === 201
      ) {
        message.success(result?.response?.data?.message);
        fetchPincodes();
      } else {
        message.error(result?.response?.data?.message || "Failed to update");
      }
    } catch (error) {
      message.error(error?.response?.data?.message || "Failed to update");
    } finally {
      setLoading(false);
    }
  };

  const handleToggleActive = async (pincode, checked) => {
    try {
      setLoading(true);

      const payload = {
        dpId: selectedDP,
        type: selectedType,
        isActive: checked,
        pincode: parseInt(pincode),
      };

      // Use PATCH method with the toggle-active endpoint
      const result = await API.Api(
        `${SERVICEABILITY_API}/toggle-active`
      ).patchCustomHeader(payload, {
        kid: "1",
        authtype: "jwt",
        "Content-Type": "application/json",
      });

      if (
        result?.response?.status === 200 ||
        result?.response?.status === 201
      ) {
        message.success(result?.response?.data?.message);
        fetchPincodes();
      } else {
        message.error(
          result?.response?.data?.message || "Failed to update active status"
        );
      }
    } catch (error) {
      message.error(
        error?.response?.data?.message || "Failed to update active status"
      );
    } finally {
      setLoading(false);
    }
  };

  // Unified function to handle both single and bulk pincode addition
  const addPincodes = async (pincodeList) => {
    if (!pincodeList || pincodeList.length === 0) {
      return;
    }

    try {
      setLoading(true);

      const payload = {
        dpId: selectedDP,
        pincodes: pincodeList,
        type: selectedType,
        FM: bulkFM, //pincodeList === validPincodes ? bulkFM : fm,
        LM: bulkLM, //pincodeList === validPincodes ? bulkLM : lm,
        isCod: bulkCOD, //pincodeList === validPincodes ? bulkCOD : cod,
      };

      const result = await API.Api(SERVICEABILITY_API).post(payload);

      if (
        result?.response?.status === 200 ||
        result?.response?.status === 201
      ) {
        message.success(result?.response?.data?.message);
        fetchPincodes();

        // Reset form based on which type of addition was performed
        setIsBulkModalOpen(false);
        setBulkInput("");
        setBulkErrorMessage("");
        setValidPincodes([]);
        setBulkFM(false);
        setBulkLM(false);
        setBulkCOD(false);

        setPincode("");
        setIsModalOpen(false);
        setFM(false);
        setLM(false);
        setCOD(false);
      } else {
        message.error(
          result?.response?.data?.message || "Failed to add pincode(s)"
        );
      }
    } catch (error) {
      message.error(
        error?.response?.data?.message || "Failed to add pincode(s)"
      );
    } finally {
      setLoading(false);
    }
  };

  // const handleAddSinglePincode = async () => {
  //   // Validate pincode
  //   if (!pincode.trim()) {
  //     message.error("Please enter a pincode");
  //     return;
  //   }

  //   if (!/^\d{6}$/.test(pincode)) {
  //     message.error("Pincode must be a 6-digit number");
  //     return;
  //   }

  //   const numericPincode = parseInt(pincode, 10);

  //   // Check if pincode already exists
  //   if (pincodes.find((p) => p.pincode === numericPincode)) {
  //     message.warning("This pincode has already been added");
  //     setPincode("");
  //     return;
  //   }

  //   // Use the unified function with a single-item array
  //   await addPincodes([numericPincode]);
  // };

  const validateBulkPincodes = () => {
    if (!bulkInput.trim()) {
      setBulkErrorMessage("Please enter at least one pincode");
      return false;
    }

    // Split by commas, line breaks, or spaces and filter out empty strings
    const rawPincodes = bulkInput
      .split(/[\s,\n]+/)
      .map((code) => code.trim())
      .filter((code) => code.length > 0);

    // Validate each pincode
    const valid = [];
    const invalidPincodes = [];
    const duplicatePincodes = [];

    rawPincodes.forEach((pincode) => {
      if (/^\d{6}$/.test(pincode)) {
        const numericPincode = parseInt(pincode, 10);

        if (pincodes.find((p) => p.pincode === numericPincode)) {
          duplicatePincodes.push(pincode);
        } else if (valid.includes(numericPincode)) {
          duplicatePincodes.push(pincode);
        } else {
          valid.push(numericPincode);
        }
      } else if (pincode.length > 0) {
        invalidPincodes.push(pincode);
      }
    });

    // Build error messages
    let errorMsgs = [];

    if (invalidPincodes.length > 0) {
      errorMsgs.push(
        `Invalid pincodes (must be 6 digits): ${invalidPincodes.join(", ")}`
      );
    }

    if (duplicatePincodes.length > 0) {
      errorMsgs.push(`Duplicate pincodes: ${duplicatePincodes.join(", ")}`);
    }

    if (valid.length === 0) {
      errorMsgs.push("No valid pincodes found to add");
      setBulkErrorMessage(errorMsgs.join("\n"));
      return false;
    }

    if (errorMsgs.length > 0) {
      setBulkErrorMessage(errorMsgs.join("\n"));
    }

    // Update state but also return the valid pincodes directly
    setValidPincodes(valid);
    return valid;
  };

  const processBulkPincodes = async () => {
    // Validate and get valid pincodes directly
    const validPincodesList = validateBulkPincodes();
    if (!validPincodesList) {
      return;
    }

    // Add valid pincodes in a single API call using the direct result
    await addPincodes(validPincodesList);
  };

  const handleDPChange = (value) => {
    setSelectedDP(value);
  };

  const columns = [
    {
      key: "pincode",
      title: "Pincode",
      dataIndex: "pincode",
      render: (text) => <span style={{ fontWeight: 500 }}>{text}</span>,
    },
    {
      key: "FM",
      title: "FM",
      dataIndex: "FM",
      render: (val, record) => (
        <Checkbox
          checked={!!val}
          onChange={(e) =>
            handleCheckboxChange(record.pincode, "FM", e.target.checked)
          }
          disabled={!record.isActive}
        />
      ),
    },
    {
      key: "LM",
      title: "LM",
      dataIndex: "LM",
      render: (val, record) => (
        <Checkbox
          checked={!!val}
          onChange={(e) =>
            handleCheckboxChange(record.pincode, "LM", e.target.checked)
          }
          disabled={!record.isActive}
        />
      ),
    },
    {
      key: "isCod",
      title: "COD",
      dataIndex: "isCod",
      render: (val, record) => (
        <Checkbox
          checked={!!val}
          onChange={(e) =>
            handleCheckboxChange(record.pincode, "isCod", e.target.checked)
          }
          disabled={!record.isActive}
        />
      ),
    },
    {
      key: "isActive",
      title: "Active",
      dataIndex: "isActive",
      render: (val, record) => (
        <Switch
          checked={!!val}
          onChange={(checked) => handleToggleActive(record.pincode, checked)}
          size="small"
        />
      ),
    },
    {
      key: "action",
      title: "Action",
      align: "right",
      render: (_, record) => (
        <Button
          type="link"
          danger
          icon={<DeleteOutlined />}
          onClick={() => showDeleteConfirm(record.pincode)}
        />
      ),
    },
  ];

  return (
    <>
      <div className="master-main-container m-1 mt-3 p-1">
        <div className="row">
          <b className="master-title">Delivery Partner Pincodes</b>
        </div>

        <Row gutter={16} className="mt-1">
          <Col span={6}>
            <Select
              placeholder="Delivery Partner Name"
              className="border-radius-5 w-100"
              onChange={handleDPChange}
              value={selectedDP}
              loading={loading}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {deliveryPartners.map((dp) => (
                <Select.Option key={dp.dpId} value={dp.dpId}>
                  {dp.dpName}
                </Select.Option>
              ))}
            </Select>
          </Col>
          <Col span={6}>
            <Select
              placeholder="Select Type"
              className="border-radius-5 w-100"
              value={selectedType}
              disabled
            >
              <Select.Option value="ECOMM">ECOMM</Select.Option>
              <Select.Option value="CARGO">CARGO</Select.Option>
            </Select>
          </Col>
        </Row>

        <Card className="mt-1">
          <Row>
            <h4 className="master-title">Pincodes</h4>
            {selectedDP && (
              <Button
                style={{ marginLeft: "auto" }}
                className="btn-style cancel-btn px-3 w-20"
                type="primary"
                onClick={() => {
                  // Reset form values before opening modal
                  setPincode("");
                  setFM(false);
                  setLM(false);
                  setCOD(false);
                  setBulkFM(false);
                  setBulkLM(false);
                  setBulkCOD(false);
                  setIsModalOpen(true);
                  setIsBulkModalOpen(true);
                }}
              >
                Add Pincodes
              </Button>
            )}
          </Row>
          {pincodes.length === 0 ? (
            <div className="text-center p-3">
              No pincodes found for this delivery partner
            </div>
          ) : (
            <TableContainer
              columns={columns}
              dataSource={pincodes}
              pagination={{ pageSize: 10 }}
              rowClassName={() => "custom-table-row"}
            />
          )}
        </Card>
      </div>

      {/* Add Pincode Modal */}
      {/* <Modal
        title="Add Pincode"
        open={isModalOpen}
        onCancel={handleCancel}
        footer={null}
      >
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <div className="pincode-input-container">
              <div
                className="input-row"
                style={{ display: "flex", gap: "10px", marginBottom: "16px" }}
              >
                <Input
                  placeholder="Enter 6-digit pincode"
                  value={pincode}
                  onChange={handlePincodeChange}
                  onPressEnter={handleAddSinglePincode}
                  className="border-radius-5"
                  style={{ flex: 1 }}
                  maxLength={6}
                />
                <Button
                  type="primary"
                  icon={<PlusOutlined />}
                  onClick={() => setIsBulkModalOpen(true)}
                >
                  Bulk Add
                </Button>
              </div>
            </div>
          </Col>
          <Col span={24}>
            <Select
              placeholder="Select Type"
              className="border-radius-5 w-100"
              value={selectedType}
              disabled
            >
              <Select.Option value="ECOMM">ECOMM</Select.Option>
              <Select.Option value="CARGO">CARGO</Select.Option>
            </Select>
          </Col>
          <Col span={24} style={{ display: "flex", gap: 16 }}>
            <Checkbox
              checked={fm}
              onChange={(e) => {
                const isChecked = Boolean(e.target.checked);
                setFM(isChecked);
              }}
            >
              FM
            </Checkbox>
            <Checkbox
              checked={lm}
              onChange={(e) => {
                const isChecked = Boolean(e.target.checked);
                setLM(isChecked);
              }}
            >
              LM
            </Checkbox>
            <Checkbox
              checked={cod}
              onChange={(e) => {
                const isChecked = Boolean(e.target.checked);
                setCOD(isChecked);
              }}
            >
              COD
            </Checkbox>
          </Col>
          <Col
            span={24}
            className="text-right"
            style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}
          >
            <Button onClick={handleCancel}>Cancel</Button>
            <Button
              type="primary"
              onClick={handleAddSinglePincode}
              className="border-radius-5"
            >
              Add Pincode
            </Button>
          </Col>
        </Row>
      </Modal> */}

      {/* Bulk Add Modal */}
      <Modal
        title="Add Pincodes"
        open={isBulkModalOpen}
        onCancel={handleBulkCancel}
        footer={[
          <Button key="cancel" onClick={handleBulkCancel}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={processBulkPincodes}
            loading={loading}
          >
            Add Pincodes
          </Button>,
        ]}
        width={600}
      >
        <div className="bulk-input-container">
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <Text>
                Enter multiple 6-digit pincodes (separated by commas, spaces, or
                new lines):
              </Text>
              <TextArea
                value={bulkInput}
                onChange={handleBulkInputChange}
                placeholder="e.g. 301001, 301002, 301705&#10;302001 302002 302003&#10;302004"
                rows={8}
                className="bulk-input"
                style={{ marginTop: "8px", marginBottom: "8px" }}
              />
              {bulkErrorMessage && (
                <div className="error-message">
                  {bulkErrorMessage.split("\n").map((error, index) => (
                    <Text
                      key={index}
                      type="danger"
                      style={{ display: "block" }}
                    >
                      {error}
                    </Text>
                  ))}
                </div>
              )}
            </Col>

            <Col span={24}>
              <Select
                placeholder="Select Type"
                className="border-radius-5 w-100"
                value={selectedType}
                disabled
              >
                <Select.Option value="ECOMM">ECOMM</Select.Option>
                <Select.Option value="CARGO">CARGO</Select.Option>
              </Select>
            </Col>

            <Col span={24} style={{ display: "flex", gap: 16 }}>
              <Checkbox
                checked={bulkFM}
                onChange={(e) => {
                  const isChecked = Boolean(e.target.checked);
                  setBulkFM(isChecked);
                }}
              >
                FM
              </Checkbox>
              <Checkbox
                checked={bulkLM}
                onChange={(e) => {
                  const isChecked = Boolean(e.target.checked);
                  setBulkLM(isChecked);
                }}
              >
                LM
              </Checkbox>
              <Checkbox
                checked={bulkCOD}
                onChange={(e) => {
                  const isChecked = Boolean(e.target.checked);
                  setBulkCOD(isChecked);
                }}
              >
                COD
              </Checkbox>
            </Col>
          </Row>
        </div>
      </Modal>

      {/* Delete Confirmation Modal */}
      <Modal
        title="Delete Pincode"
        open={isDeleteModalOpen}
        onCancel={handleDeleteCancel}
        footer={[
          <Button key="cancel" onClick={handleDeleteCancel}>
            Cancel
          </Button>,
          <Button
            key="delete"
            type="primary"
            danger
            onClick={confirmDelete}
            loading={loading}
          >
            Delete
          </Button>,
        ]}
      >
        <p>Are you sure you want to delete this pincode?</p>
      </Modal>
    </>
  );
};

export default DPPincodeList;
